import cookies from 'browser-cookies';
import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { ptBR } from 'date-fns/locale';

import i18n from './i18n/config';
import AppMountNotifier from './src/components/app-mount-notifier';
import { createStore } from './src/redux/create-store';
import layoutSelector from './utils/gatsby/layout-selector';
import GrowthBookProvider from './src/components/growth-book/growth-book-wrapper';
import LearnLayout from './src/components/learn-layout';

import './src/styles/themes.css';
import './src/styles/custom.scss';

// Make React and ReactDOM available globally for iframe test contexts
if (globalThis.window) {
  globalThis.window.React = React;
  globalThis.window.ReactDOM = ReactDOM;
}

const store = createStore();

export const wrapRootElement = ({ element }) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
      <Provider store={store}>
        <I18nextProvider i18n={i18n}>
          <GrowthBookProvider>
            <LearnLayout>
              <AppMountNotifier render={() => element} />
            </LearnLayout>
          </GrowthBookProvider>
        </I18nextProvider>
      </Provider>
    </LocalizationProvider>
  );
};

wrapRootElement.propTypes = {
  element: PropTypes.any
};

export const wrapPageElement = layoutSelector;

export const disableCorePrefetching = () => true;

export const onClientEntry = () => {
  // the token must be erased since it is only valid for the old _csrf secret
  cookies.erase('csrf_token');
};

export const onRouteUpdate = () => {
  if (globalThis.window) {
    globalThis.window.locations = globalThis.window.locations || [
      document.referrer
    ];
    globalThis.window.locations.push(globalThis.window.location.href);
    globalThis.window.previousPath =
      globalThis.window.locations[globalThis.window.locations.length - 2];
  }
};
